import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import markerSDK from "@marker.io/browser";
import { defaultMarkerIODestination } from "../utils/env";

let widgetInstance = null;
let loadingPromise = null;

export default function useMarkerIO() {
  const tenantDestination = useSelector(
    (state) => state.layout.markerIODestination
  );
  const destination = tenantDestination || defaultMarkerIODestination || "";
  const prevDestination = useRef(null);

  useEffect(() => {
    if (!destination || destination === prevDestination.current) return;
    prevDestination.current = destination;

    if (widgetInstance) {
      widgetInstance.unload();
      widgetInstance = null;
      loadingPromise = null;
    }

    loadingPromise = markerSDK
      .loadWidget({
        destination,
        silent: true,
        reporter: { email: "ai-chat@insightout.ai", fullName: "AI Chat" },
      })
      .then((widget) => {
        widgetInstance = widget;
        widget.hide();
      })
      .catch((err) => {
        console.error("Failed to load Marker.io widget:", err);
        loadingPromise = null;
      });
  }, [destination]);

  const captureWithContext = async (customData) => {
    if (!destination) return;

    if (!widgetInstance && loadingPromise) {
      await loadingPromise;
    }

    if (!widgetInstance) return;

    widgetInstance.setCustomData(customData);
    widgetInstance.capture("fullscreen");
  };

  return { captureWithContext };
}
